'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const getAirportInfo = (pageName, airportCodes, codeSwap = {}, airportMatch = {}) => {
  let location;
  Object.keys(airportCodes).map(key => {
    const item = airportCodes[key];
    const regEx = new RegExp(item.pattern);
    if (regEx.test(pageName)) {
      location = {
        name: item.name,
        code: codeSwap[item._airport] || item._airport,
        pattern: item.pattern
      };
    }
    return key;
  });
  if (!location && airportMatch.hasOwnProperty(pageName.replace('.html', ''))) {
    location = airportMatch[pageName.replace('.html', '')];
  }
  return location;
};
var _default = exports.default = getAirportInfo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/getAirportInfo.js
// module id = 740
// module chunks = 119